import type { AnimationTheme } from '@/types/animationThemes';

/**
 * Auto-assign animation theme based on template/category.
 * Removes the need for a separate reveal selection step.
 */
export function getAutoAnimationTheme(template: string): AnimationTheme {
  const map: Record<string, AnimationTheme> = {
    love: 'golden_light',
    gratitude: 'elegant_floral',
    apology: 'handwritten_journal',
    closure: 'ornate_keepsake',
    hard_conversation: 'memory_constellation',
    celebration: 'blooming_garden',
    anniversary: 'golden_light',
    birthday: 'blooming_garden',
    custom: 'elegant_floral',
    encouragement: 'blooming_garden',
  };
  return map[template] || 'elegant_floral';
}

/**
 * Auto-assign typography preset based on template.
 */
export function getAutoTypography(template: string): 'classic' | 'modern' | 'handwritten' {
  const map: Record<string, 'classic' | 'modern' | 'handwritten'> = {
    love: 'classic',
    gratitude: 'classic',
    apology: 'handwritten',
    closure: 'classic',
    hard_conversation: 'modern',
    celebration: 'modern',
    anniversary: 'classic',
    birthday: 'modern',
    custom: 'classic',
    encouragement: 'modern',
  };
  return map[template] || 'classic';
}
